import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Stack, Typography, Chip,
  CircularProgress, Alert
} from '@mui/material';
import { Payments, Edit } from '@mui/icons-material';
import { updateUpahTukang } from '../API/upahTukang';

const TAHAP_LABEL = { tahap_1: 'Tahap I (30-50%)', tahap_2: 'Tahap II (100%)' };

const ModalEditUpahTukang = ({ open, onClose, data, onSuccess }) => {
  const [form, setForm] = useState({ nominal: '', keterangan: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (open && data) {
      setForm({
        nominal: data.totalUpah || '',
        keterangan: data.keterangan || ''
      });
    }
  }, [open, data]);

  const handleSubmit = async () => {
    if (!form.nominal || Number(form.nominal) <= 0) {
      setError('Nominal harus diisi');
      return;
    }
    setError(null);
    setSaving(true);
    try {
      await updateUpahTukang(data.id, {
        nominal: Number(form.nominal),
        keterangan: form.keterangan || ''
      });
      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || 'Gagal mengupdate data');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ bgcolor: 'warning.main', color: 'white' }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Edit />
          <Typography variant="h6">Edit Upah Tukang</Typography>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        {error && <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>{error}</Alert>}

        <Stack spacing={2} sx={{ mt: 1 }}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="body2" color="text.secondary">Tahap:</Typography>
            <Chip size="small" label={TAHAP_LABEL[data?.tahap] || data?.tahap || '-'}
              color={data?.tahap === 'tahap_1' ? 'warning' : 'success'} variant="outlined" />
          </Stack>

          <TextField
            size="small"
            label="Nominal (Rp) *"
            type="number"
            value={form.nominal}
            onChange={(e) => setForm(prev => ({ ...prev, nominal: e.target.value }))}
            inputProps={{ min: 1 }}
            InputProps={{ startAdornment: <Payments sx={{ mr: 1, color: 'text.secondary' }} /> }}
          />

          <TextField
            size="small"
            label="Keterangan (opsional)"
            multiline
            rows={2}
            value={form.keterangan}
            onChange={(e) => setForm(prev => ({ ...prev, keterangan: e.target.value }))}
          />
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} disabled={saving}>Batal</Button>
        <Button variant="contained" color="warning" onClick={handleSubmit} disabled={saving}
          startIcon={saving ? <CircularProgress size={20} color="inherit" /> : null}>
          {saving ? 'Menyimpan...' : 'Update'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ModalEditUpahTukang;